import { Injectable } from "@angular/core";
import { Permission } from "@auth/models/permission";
import { AccessToken, IAzaraAccessToken } from "@auth/models/token";
import { OAuthService } from "angular-oauth2-oidc";
import { DateTime } from "luxon";

@Injectable({
    providedIn: "root",
})
export class TokenService {
    constructor(private oauthService: OAuthService) {}

    public isTokenClaimsValid() {
        const token = this.getToken();

        return !!token?.tenant;
    }

    public getToken(): AccessToken | null {
        const token = this.getDecodedAccessToken();

        if (!token) return null;

        return {
            sid: token.sid,
            sub: token.sub,
            aud: token.aud,
            exp: token.exp,
            scope: token.scope,
            authTime: DateTime.fromSeconds(token.auth_time),
            expiration: DateTime.fromSeconds(token.exp),
            userEmail: token.name,
            userFirstName: token.given_name,
            userLastName: token.family_name,
            idsClientId: token.client_id,
            planId: Number(token.plan_id),
            tenant: token.tenant,
            viewPhi: (token.view_phi ?? "").toLowerCase() === "true",
            centerId: Number(token.center_id),
            permission: token.permission,
            identityProvider: token.idp,
        };
    }

    public hasPermissions(requiredPermissions: Permission[]): boolean {
        const tokenPermissions = this.getToken()?.permission;

        if (!tokenPermissions) return false;

        if (Array.isArray(tokenPermissions)) {
            return requiredPermissions.every((p) =>
                tokenPermissions.includes(p),
            );
        }

        if (requiredPermissions.length > 1) return false;
        return requiredPermissions[0] === tokenPermissions;
    }

    private getDecodedAccessToken(): IAzaraAccessToken | null {
        const token = this.oauthService.getAccessToken();
        const payload = token?.split(".")?.[1];

        if (payload) {
            return JSON.parse(atob(payload));
        }

        return null;
    }
}
